<template>
    <fileloader
        :doc_id="tender.id"
        doc_type="tender"
        :url_remove="tender_file_url"
        :url_load="tender_file_url"
        v-bind:trigger_load="file_trigger"
        v-bind:can_del="true"
        :enable-preview=false
        :simpleLoader="true"
        :files="[]"
    >
    </fileloader>
    
    <BTable striped :items="tender.files" :fields="fields">
        <template v-slot:cell(comment)="{ value, item, field: { key }}">
            <BFormInput v-model="item[key]" type="text" placeholder="Опис файла"/>
        </template>
        
        <template v-slot:cell(name)="{ value, item, field: { key }}">
            <a href="#" @click="getFile(item)">
                {{item.name}}
            </a>
        </template>
        
        <template v-slot:cell(dell_row)="row">
            <div class='icon-stack cursor-pointer fs-xxl' v-on:click="dellFile(row.item)">
                <i class="base base-1 icon-stack-3x opacity-100 color-danger-600"></i>
                <i class="far fa-trash-alt icon-stack-1x opacity-100 color-white"></i>
            </div>
        </template>
    </BTable>

</template>

<script>
import fileloader from "../../../../shared/file_loader/fileloader.vue";

import {
    BTable,
    BFormGroup,
    BFormInput,
} from 'bootstrap-vue-next';



export default {
    name: "tender_files",
    components: {
        BTable,
        BFormInput,
        fileloader
    },
    emits : ['changeAtr'],
    
    props : {
        tender : {
            type : Object
        }
    },
    
    data() {
        return {
            "file_trigger" : "loadedDoc",
            fields: [
                {key: 'name', label: 'Файл'},
                {key: 'comment', label: 'Примітка'},
                {key: 'dell_row', label: 'Видалити',}
            ]
        }
    },
    
    created() {
        EventBus.$on(this.file_trigger,this.operateLoad);
    },
    
    methods : {
        
        getFile(file) {
            console.log(file);
            window.location.href = '/internal/media/file/' + file.file_id;
        },
        
        async operateLoad(info) {
            let file_id = info.file_id;
            let full_file = info.full_file;
            console.log('trigger',info);
            
            if(info.type === 'file_loaded') {
                this.tender.files.push({
                    'name'          : full_file?.name,
                    'file_id'       : file_id,
                    'comment'       : "",
                });
            }
            
            if(info.type === 'file_deleted') {
                this.tender.files = this.tender.files.filter(file => {
                     return parseInt(file.file_id) !== parseInt(file_id);
                });
            }
        },
        
        async dellFile(file) {
            console.log('remove',file);
            await api.delete(this.tender_file_url + '/' + parseInt(file.file_id)).then(({data}) => {
                this.operateLoad({
                    'type' : "file_deleted",
                    file_id : file.file_id
                });
            }).catch(e => {
                EventBus.$emit('show_toast', {
                    err: response.data.message,
                    type: "danger",
                    title: response.data.status
                });
            })
        }
    },
    
    computed: {
        tender_file_url () {
            return '/tenders/sales/tenders/' + this.tender.id + '/file';
        },
    }
    
}
</script>



<style scoped>

</style>